import Cookies from "js-cookie";

import { useCallback, useState } from "react";

export function useCookie(name: string, initialValue: any) {
  const [value, setValue] = useState(Cookies.get(name) || initialValue);

  const setCookie = useCallback(
    (newValue: string, options?: Cookies.CookieAttributes) => {
      Cookies.set(name, newValue, options);
      setValue(newValue);
    },
    [name],
  );

  const removeCookie = useCallback(() => {
    Cookies.remove(name);
    setValue(null);
  }, [name]);

  return [value, setCookie, removeCookie];
}
